import { Helmet } from 'react-helmet-async';

const PageTitle = ({ title, description }) => {
  const fullTitle = title ? `${title} — Lagree MVMT` : 'Lagree MVMT — The Authentic Lagree Studio at Home';
  const defaultDesc = 'Premium Lagree fitness equipment and on-demand classes. Experience the authentic Lagree Method at home.';
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDesc} />
    </Helmet>
  );
};

export default PageTitle;
